Devise.addUserScope("user")
